// Match [[tag]]
const tagRegEx = /\[\[(?:[^[\]]+|\[[^\]]*\])*\]\]/giu

export type TextTag = {
    tag: string
    name: string
    value?: string
    description?: string
}

export type TextTagCategory = {
    key: string
    category: string
}

export type TextTagToken = {
    text: string
    tag?: TextTag
    tagInnerText?: string
    isTag: boolean
}

export const isTextTagCategory = (tag: TextTag | TextTagCategory): tag is TextTagCategory => {
    return 'category' in tag
}

export const isTextTag = (tag: TextTag | TextTagCategory): tag is TextTag => {
    return !isTextTagCategory(tag)
}

export const extractTextTags = ({ text, tags }: { text: string; tags: TextTag[] }): TextTagToken[] => {
    //
    // Split the text with the regex
    //

    const textTokens = []
    let lastIndex = 0

    for (const m of text.matchAll(tagRegEx)) {
        if (m.index > lastIndex) {
            textTokens.push(text.slice(lastIndex, m.index))
        }
        textTokens.push(m[0]) // token
        lastIndex = m.index + m[0].length
    }

    if (lastIndex < text.length) {
        textTokens.push(text.slice(lastIndex))
    }

    return textTokens.map((textToken) => {
        let tag: TextTag | undefined = undefined
        let isTag = false
        let tagInnerText: string | undefined = undefined

        if (textToken.startsWith('[[') && textToken.endsWith(']]')) {
            isTag = true
            tagInnerText = textToken.substring(2, textToken.length - 2)
            tag = tags.find(({ tag }) => tag.toLowerCase() === tagInnerText?.toLowerCase())
        }

        return { text: textToken, tag, isTag, tagInnerText }
    })
}

export const replaceTextTags = ({
    text,
    tags,
    clearUnknownTags = false,
    clearUndefinedTagValues = true,
}: {
    text: string
    tags: TextTag[]
    clearUnknownTags?: boolean
    clearUndefinedTagValues?: boolean
}) => {
    if (!text) {
        return ''
    }

    const tokens = extractTextTags({ text, tags })

    return tokens
        .map(({ text, tag, isTag }) => {
            if (tag) {
                if (tag.value !== undefined) {
                    return tag.value
                }

                if (clearUndefinedTagValues) {
                    return ''
                }

                return `[${tag.name}]`
            }

            if (isTag && clearUnknownTags) {
                return ''
            }

            return text
        })
        .join('')
}
